const en = {
  /* ── Navbar ─────────────────────────────── */
  nav_about: 'About Us',
  nav_products: 'Products',
  nav_features: 'Why Us',
  nav_contact: 'Contact',
  nav_cta: 'Request Quote',
  nav_menu_open: 'Open menu',

  /* ── Hero ──────────────────────────────── */
  hero_badge: 'PIPE · TUBE\u00a0·\u00a0FITTING · FLANGE · PILE · PE COATING',
  hero_title_line1: 'Your Trusted',
  hero_title_highlight: 'Partner',
  hero_title_line3: 'in Steel Pipe',
  hero_subtitle: 'Synergy Steel delivers pipes, fittings, flanges, piles, and PE-coated pipes with competitive pricing and fast delivery to every job site.',
  hero_stat1_label: 'Yrs Experience',
  hero_stat2_label: 'Project Sites',
  hero_cta_quote: 'Free Quote Request',
  hero_cta_products: 'View Products',
  hero_scroll: 'SCROLL',

  /* ── About ─────────────────────────────── */
  about_section_label: '/ ABOUT SYNERGY STEEL',
  about_title_line1: 'Your Steel Pipe Partner,',
  about_title_highlight: 'Synergy Steel',
  about_title_line2: ' — Start to Finish',
  about_para1: 'With over 15 years of field experience, we provide customized material solutions and promise prompt delivery. Synergy Steel operates a stable nationwide supply chain and was honored with the "Million Dollar Export Tower" at Korea Trade Day 2022, demonstrating our competitiveness in the global market.',
  about_para2: 'We apply strict quality control standards, supplying only products that conform to international specifications (ASTM, API, ASME, etc.) and proposing optimal specifications tailored to each project. Our extensive supply experience spans EPC contractors, construction firms, and distributors, with flexible response to urgent orders and small-lot requirements.',
  about_para3: 'Beyond simple material supply, Synergy Steel acts as a true project partner — delivering competitive pricing, reliable quality, and responsible service. We will continue expanding our supply chain and elevating quality standards to keep customer satisfaction at the forefront.',
  about_cert0_label: 'KS Certified',
  about_cert0_sub: 'Korean Industrial Standard',
  about_cert1_label: 'ISO 9001',
  about_cert1_sub: 'Quality Management System',
  about_cert2_label: 'Gov. Procurement',
  about_cert2_sub: 'Public Purchase Certified',
  about_img_alt: 'CEO No Dong-min',

  /* ── Products ──────────────────────────── */
  products_section_label: '/ PRODUCTS',
  products_title: 'Product Lineup',
  products_subtitle: 'All products comply with KS and international standards with quality certificates provided.',
  products_spec_btn: 'View Spec Table',
  products_quote_btn: 'Request Quote',
  /* main products */
  prod_pipe_name: 'Pipe',
  prod_fitting_name: 'Fitting',
  prod_fitting_desc: 'We supply a wide range of pipe fittings including elbows, tees, reducers, and caps. High pressure performance and precise dimensions ensure safety at every industrial site.',
  prod_fitting_tag0: 'Elbow',
  prod_fitting_tag1: 'Tee',
  prod_fitting_tag2: 'Reducer',
  prod_fitting_tag3: 'Cap',
  prod_flange_name: 'Flange',
  prod_flange_desc: 'All types of flanges — WN, SO, BL, SW, LJ, TH — supplied to KS and ANSI/ASME standards. Reliable sealing performance guaranteed even in high-pressure and high-temperature environments.',
  prod_flange_tag0: 'WN Type',
  prod_flange_tag1: 'SO Type',
  prod_flange_tag2: 'BL Type',
  prod_flange_tag3: 'SW Type',
  prod_pile_name: 'Steel Pipe Pile',
  prod_pile_desc: 'Large-diameter steel pipe piles used for building foundations and large civil structures. Superior vertical and lateral load resistance makes them ideal for high-rise buildings, bridges, and port construction.',
  prod_pile_tag0: 'Steel Pile',
  prod_pile_tag1: 'Large Diameter',
  prod_pile_tag2: 'Foundation Work',
  prod_pile_tag3: 'KS F 4602',
  prod_pe_coating_name: 'PE Coating',
  prod_pe_coating_desc: 'Polyethylene (PE) coating applied to the pipe exterior for corrosion protection. Ensures long-term durability even in harsh environments such as buried or subsea pipelines.',
  prod_pe_coating_tag0: '3LPE',
  prod_pe_coating_tag1: 'Anti-Corrosion',
  prod_pe_coating_tag2: 'Buried Piping',
  /* pipe subtypes */
  pipe_seamless_name: 'Seamless Pipe',
  pipe_seamless_desc: 'High-quality seamless steel pipes manufactured without weld seams. Uniform strength and excellent pressure resistance make them ideal for power plants, petrochemical plants, and boiler piping requiring high temperature and pressure.',
  pipe_seamless_tag0: 'No Weld Seam',
  pipe_seamless_tag1: 'High Pressure',
  pipe_seamless_tag2: 'Boiler Use',
  pipe_seamless_tag3: 'ASTM A106',
  pipe_pressure_name: 'Pressure Pipe',
  pipe_pressure_desc: 'Pressure piping steel pipe specialized for high-pressure fluid and steam transport. Compliant with KS D3562 and ASME/ANSI standards; thick wall and rigorous non-destructive testing ensure safety of plant equipment.',
  pipe_pressure_tag0: 'Pressure Piping',
  pipe_pressure_tag1: 'KS D3562',
  pipe_pressure_tag2: 'SCH 40~160',
  pipe_pressure_tag3: 'NDT Tested',
  pipe_general_name: 'General Pipe',
  pipe_general_desc: 'General-purpose carbon steel pipe for water supply/drainage, building piping, and HVAC systems. Cost-effective and easy to install, with stable quality per KS D3507 / KS D3595 standards.',
  pipe_general_tag0: 'General Piping',
  pipe_general_tag1: 'KS D3507',
  pipe_general_tag2: 'Multipurpose',
  pipe_general_tag3: 'Water / Drain',
  pipe_structural_name: 'Structural Pipe',
  pipe_structural_desc: 'Steel pipes used as load-bearing structural members in buildings, bridges, and steel frameworks. Available in round, square, and rectangular sections with excellent buckling resistance and high section efficiency.',
  pipe_structural_tag0: 'Round Section',
  pipe_structural_tag1: 'Square Section',
  pipe_structural_tag2: 'Structural Use',
  pipe_structural_tag3: 'KS D3566',
  pipe_stainless_name: 'Stainless Steel Pipe',
  pipe_stainless_desc: 'Stainless steel pipes for environments where hygiene and corrosion resistance are critical, such as food processing, pharmaceutical, and chemical plants. Multiple grades (SUS304/SUS316L) and BA/EP surface finishes provide high-value piping solutions.',
  pipe_stainless_tag0: 'SUS304',
  pipe_stainless_tag1: 'SUS316L',
  pipe_stainless_tag2: 'Food Grade',
  pipe_stainless_tag3: 'Sanitary Piping',
  pipe_alloy_name: 'Alloy Steel Pipe',
  pipe_alloy_desc: 'Chromium-molybdenum alloy steel pipes for power plants and petrochemical plants in high-temperature and high-pressure environments. Excellent heat resistance and long-term creep strength make them the key piping material for supercritical power plants and refineries.',
  pipe_alloy_tag0: 'P11',
  pipe_alloy_tag1: 'P22',
  pipe_alloy_tag2: 'P91',
  pipe_alloy_tag3: 'High Temp/Press',

  /* ── Features ──────────────────────────── */
  features_section_label: '/ WHY SYNERGY STEEL',
  features_title: 'Why Choose Synergy Steel',
  features_subtitle: 'A steel pipe specialist that puts your job site first',
  feat0_title: 'Strict Quality Control',
  feat0_desc: 'We strictly comply with domestic and international standards including KS, ASTM, and JIS, issuing quality inspection certificates for every product. Your on-site safety is our top priority.',
  feat0_highlight: 'KS / ASTM / JIS Compliant',
  feat1_title: 'Fast Delivery Guarantee',
  feat1_desc: 'Our systematic inventory management system enables rapid response even to urgent orders. We leverage a nationwide network to deliver on schedule, no matter the site requirements.',
  feat1_highlight: 'Ready to Ship within 24h',
  feat2_title: 'Expert Technical Support',
  feat2_desc: 'Steel pipe specialists with 15+ years of experience provide one-stop technical support from product selection to installation. Even complex projects are resolved with the optimal solution.',
  feat2_highlight: '15+ Years of Expertise',
  feat3_title: 'Competitive Pricing',
  feat3_desc: 'Through direct imports and close partnerships with domestic manufacturers, we minimize middleman markups and deliver the best value to our customers.',
  feat3_highlight: 'Direct Import Pricing',
  feat4_title: 'Global Supply Network',
  feat4_desc: 'We have established direct-trade relationships with leading manufacturers in Korea, Japan, China, and Europe, enabling stable procurement of products in any specification and material.',
  feat4_highlight: 'Network in 4 Countries',
  feat5_title: 'Responsible After-Sales Service',
  feat5_desc: 'Even after delivery, we maintain long-term partnerships through ongoing technical support and fast replacement services.',
  feat5_highlight: 'After-Delivery Responsibility',
  features_banner_title: 'Get a Quote Today',
  features_banner_subtitle: 'Our specialist will provide a customized quote within 24 hours',
  features_banner_phone_cta: 'Call Us',

  /* ── Contact ───────────────────────────── */
  contact_section_label: '/ CONTACT US',
  contact_title_line1: 'Feel Free to',
  contact_title_line2: 'Contact Us',
  contact_subtitle: 'We welcome quote and technical inquiries for pipes, fittings, flanges, piles, and PE coating products. Our specialists will respond within 24 hours.',
  contact_info_mobile: 'Mobile',
  contact_info_phone: 'Main Phone',
  contact_info_fax: 'Fax',
  contact_info_email: 'Email',
  contact_info_address: 'Address',
  contact_map_title: 'Synergy Steel Location',
  contact_form_title: 'Quote / Product Inquiry',
  form_name_label: 'Contact Name',
  form_name_placeholder: 'John Doe',
  form_company_label: 'Company',
  form_company_placeholder: 'Company Name',
  form_email_label: 'Email',
  form_phone_label: 'Phone',
  form_phone_placeholder: '+82-10-0000-0000',
  form_product_label: 'Product Inquiry',
  form_product_placeholder: 'Select a product',
  form_product_pipe: 'Pipe',
  form_product_fitting: 'Fitting',
  form_product_flange: 'Flange',
  form_product_pile: 'Pile',
  form_product_pe: 'PE Coating',
  form_product_other: 'Other / Multiple',
  form_message_label: 'Message',
  form_message_placeholder: 'Please describe specifications, quantities, delivery schedule, or any other requirements.',
  form_message_limit: 'Cannot exceed 500 characters.',
  form_submit: 'Send Inquiry',
  form_sending: 'Sending...',
  form_notice: 'Our team will reply within 24 business hours',
  form_error: 'Failed to send. Please try again later or call +82-2-6941-1750.',
  form_success_title: 'Inquiry Received!',
  form_success_desc: 'Our representative will contact you within 24 hours.',
  form_success_again: 'Send Another Inquiry',
  form_required: '*',

  /* ── Footer ────────────────────────────── */
  footer_brand_desc: 'Pipe · Fitting · Flange · Pile · PE Coating specialist supplier. A trusted steel pipe partner for Korea\'s industrial infrastructure.',
  footer_nav_title: 'Quick Links',
  footer_products_title: 'Products',
  footer_copyright: '© 2025 Synergy Steel. All rights reserved. CEO: No Dong-min',

  /* ── SpecModal ─────────────────────────── */
  spec_modal_subtitle: 'SPECIFICATION TABLE',
  spec_modal_title_suffix: '— Spec Table',
  spec_notes_label: 'NOTES',
  spec_footer_note: 'Custom sizes and materials available. Please contact us separately.',
  spec_custom_btn: 'Custom Spec Inquiry',
  spec_close_btn: 'Close',
  /* notes per product */
  spec_note_seamless_0: 'Seamless pipes have no weld seam, delivering uniform pressure resistance in high-temperature and high-pressure environments.',
  spec_note_seamless_1: 'SCH 160 and XXH (Double Extra Heavy) wall thicknesses are also available.',
  spec_note_seamless_2: 'Material Test Reports (MTR) and Ultrasonic Testing (UT) certificates are available upon request.',
  spec_note_pressure_0: 'Pressure piping steel pipes are shipped after hydrostatic testing.',
  spec_note_pressure_1: 'Both KS D3562 SPPS 380 and SPPS 420 strength grades are available.',
  spec_note_pressure_2: 'NDT (UT, RT) reports and Material Test Reports (MTR) are available.',
  spec_note_general_0: 'KS D3507: Carbon steel pipe for piping / KS D3595: Carbon steel pipe for general structure.',
  spec_note_general_1: 'Shipped with external rust-prevention coating (red lead or enamel).',
  spec_note_general_2: 'Large diameters DN 250 and above or special wall thicknesses require prior consultation.',
  spec_note_structural_0: 'Where multiple thickness options exist, weight is shown as a min–max range.',
  spec_note_structural_1: 'Special sections (oval, irregular, etc.) are available on separate inquiry.',
  spec_note_structural_2: 'Yield strength of structural steel pipe: 355 MPa or higher (KS D3566 SHK400W).',
  spec_note_stainless_0: 'Materials: SUS304 (standard) / SUS304L / SUS316 / SUS316L available on request.',
  spec_note_stainless_1: 'Surface finish: AP (annealed & pickled) or EP (electro-polished) selectable.',
  spec_note_stainless_2: 'BA or EP finish is recommended for food and pharmaceutical piping applications.',
  spec_note_alloy_0: 'P91 (9Cr-1Mo-V): Excellent long-term creep strength — used in ultra-high-temperature/pressure plants.',
  spec_note_alloy_1: 'All alloy steel pipes are shipped after heat treatment (normalizing + tempering).',
  spec_note_alloy_2: 'MTR and NDT (UT/RT) certificates are available upon request.',
  spec_note_fitting_0: 'BW: Butt Weld / SW: Socket Weld / THD: Threaded.',
  spec_note_fitting_1: 'CS (Carbon Steel): A234 WPB / SS (Stainless): A403 WP304/316.',
  spec_note_fitting_2: 'Custom thickness, material, pressure class, and RTJ/RF face machining available.',
  spec_note_flange_0: 'WN: Weld Neck / SO: Slip On / BL: Blind.',
  spec_note_flange_1: 'Materials: A105 (CS) / A182 F304/316 (SS) / A182 F11/F22 (Alloy Steel).',
  spec_note_flange_2: 'Pressure classes 600# to 2500# and RTJ groove machining also available.',
  spec_note_pile_0: 'Joint method: field welding or mechanical coupling available.',
  spec_note_pile_1: 'Coating: standard rust-prevention; epoxy coating recommended for marine environments.',
  spec_note_pile_2: 'Large-diameter piles φ1000 and above require prior consultation on fabrication lead time and transport conditions.',
  'spec_note_pe-coating_0': '3LPP (polypropylene) coating is recommended for high-temperature and subsea pipelines.',
  'spec_note_pe-coating_1': 'FBE (Fusion Bonded Epoxy) coating can also be applied to the pipe interior.',
  'spec_note_pe-coating_2': 'Holiday (pinhole) inspection and adhesion test certificates are available upon request.',
};

export default en;
